/** Static demo data for design preview screens (Steamboat sample load). */

export const SAMPLE_LOAD = {
  po_number: '0203791',
  freight_number: 'STEAMBOAT-TR-0203791',
  pickup_date: '2026-06-23',
  delivery_date: '2026-06-25',
  weight_lbs: 4147,
  trailer_size_ft: 26,
  commodity: 'Store Fixtures',
  rate_amount: 1400,
  broker_name: 'Steamboat Transportation Group',
  pickup: {
    company_name: 'PIPP MOBILE STORAGE SYSTEMS INC',
    address: '2966 WILSON DR NW',
    city: 'WALKER',
    state: 'MI',
    zip_code: '49534',
    appointment_date: '2026-06-23',
    appointment_window: '08:00',
  },
  deliveries: [
    {
      company_name: 'BATH AND BODY WORKS CONCORD',
      address: '8111 CONCORD MILLS BLVD, SPACE NO. 315',
      city: 'CONCORD',
      state: 'NC',
      zip_code: '28027',
      appointment_date: '2026-06-25',
      appointment_window: '07:00',
    },
  ],
  assignments: {
    shipper: 'PIPP Mobile Storage (Walker, MI)',
    consignee: 'Bath and Body Works Concord Mills',
    carrier: 'Provision Global LLC',
    driver: 'Jamichael McCoy',
    truck: '1505163828',
    depot: 'Chattanooga Depot',
  },
};

export const SAMPLE_STOPS = [
  {
    sequence: 1,
    label: 'PIPP MOBILE STORAGE SYSTEMS INC',
    address: '2966 WILSON DR NW, WALKER, MI, 49534, USA',
    type: 'pickup',
  },
  {
    sequence: 2,
    label: 'Bath and Body Works Concord Mills',
    address: '8111 CONCORD MILLS BLVD, SPACE NO. 315, CONCORD, NC, 28027, USA',
    type: 'delivery',
  },
];
